import { apiGet } from './apiWrapper';
import { isNullOrUndefined } from './storeFunctions';

const initType = "INITIATE_ENTITY_INFO_REQUEST";
const failType = "RECEIVE_REQUEST_ENTITY_INFO_FAIL";
const successType = "RECEIVE_REQUEST_ENTITY_INFO_SUCCESS";
const syncSearchType = "SYNC_FROM_SEARCH_DATA";

const initialState =
{
    entityInfos: {}
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case initType:
            return updateEntityInfo(state, action.id, { isRequesting: true, result: null });
        case failType:
            return updateEntityInfo(state, action.id, { isRequesting: false, result: false });
        case successType:
            return updateEntityInfo(state, action.id, { isRequesting: false, result: action.data });
        case syncSearchType:
            for (let i = 0; i < action.data.length; i++) {
                state = updateEntityInfo(state, action.data[i].entityId, { isRequesting: false, result: action.data[i] });
            }
            return state;
        default:
            return state;
    }
}

function updateEntityInfo(state, entityId, update) {
    return { ...state, entityInfos: { ...state.entityInfos, [entityId]: isNullOrUndefined(update) ? update : { ...update, result: cleanData(update.result) } } };
}

function getUrl(entityId) { return window.babylonApiUrl + `/api/search/${entityId}`; }

function ensureEntityInfo(id, dispatch, getState, forceReload = false) {
    if (!getState().entityIdentRow.entityInfos[id] ||
        (getState().entityIdentRow.entityInfos[id].requestResult === null && getState().entityIdentRow.entityInfos[id].isRequesting === false) ||
        forceReload) {
        dispatch({ type: initType, id: id });
        apiGet(getUrl(id), null,
            response => dispatch({ type: successType, id: id, data: cleanData(response.data) }),
            () => dispatch({ type: failType, id: id })
        );
    }
}

// Cleans highlight markup from items from ES
function cleanData(data) {
    return isNullOrUndefined(data) ? data : {
        ...data,
        name: isNullOrUndefined(data.name) ? data.name : data.name.replace(/<\/?[^>]+(>|$)/g, ""),
        address: isNullOrUndefined(data.address) ? data.address : data.address.replace(/<\/?[^>]+(>|$)/g, ""),
        dic: isNullOrUndefined(data.dic) ? data.dic : data.dic.replace(/<\/?[^>]+(>|$)/g, ""),
        ico: isNullOrUndefined(data.ico) ? data.ico : data.ico.replace(/<\/?[^>]+(>|$)/g, ""),
    };
}

export const entityIdentRowActions = {
    ensureEntityInfo: (id, forceReload = false) => async (dispatch, getState) => ensureEntityInfo(id, dispatch, getState, forceReload),
    insertEntityInfo: (id, info) => dispatch => dispatch({ type: successType, id: id, data: cleanData(info) }),
    syncFromSearch: items => async (dispatch, getState) => dispatch({ type: syncSearchType, data: items })
};
